import { writable } from 'svelte/store';

export interface ToastAction {
  label: string;
  fn: () => void;
}

export interface Toast {
  id: number;
  msg: string;
  action?: ToastAction;
}

export const toasts = writable<Toast[]>([]);
let nextId = 1;

export function pushToast(
  msg: string,
  opts: { label?: string; fn?: () => void; ms?: number } = {},
): number {
  const id = nextId++;
  const action = opts.label && opts.fn ? { label: opts.label, fn: opts.fn } : undefined;
  toasts.update((t) => [...t, { id, msg, action }]);
  const ttl = opts.ms ?? (action ? 5000 : 3200);
  setTimeout(() => dismissToast(id), ttl);
  return id;
}

export function dismissToast(id: number): void {
  toasts.update((t) => t.filter((x) => x.id !== id));
}
